/**
 * An object containing various regular expressions for common validation purposes.
 * @property {string} BASE_URL - The base URL for the application.
 * @property {object} REGEX - An object containing various regular expressions.
 *   @property {RegExp} EMAIL - Regular expression for validating email addresses.
 *   @property {RegExp} SPECIALCHARACTERS - Regular expression for finding special characters in a string.
 *   @property {RegExp} NUMBER - Regular expression for finding numbers in a string.
 *   @property {RegExp} NAME - Regular expression for validating names.
 *   @property {RegExp} ALPHABETCOMMA - Regular expression for validating strings with alphabets, numbers, and commas.
 *   @property {RegExp} ADDRESS - Regular expression for validating addresses.
 */
const Constant = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    NOTICE_REPORT_ALL: '/api/notices/report/all',
    REGEX: {
        EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        SPECIALCHARACTERS: /[!@#$%^&*)(+=._-]/g,
        NUMBER: /[0-9]/,
        NAME: /^[a-zA-Z.'\-\u00C0-\u02AF ]+$/,
        ALPHABETCOMMA: /^[ a-zA-Z0-9.]+$/i,
        ADDRESS: /^[a-zA-Z0-9\s.,#-]+$/,
        ALPHANUMERIC: /^[a-zA-Z0-9\s\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]+$/i,
        LOWERCASEUPPERCASE: /[a-z].*[A-Z]|[A-Z].*[a-z]/,
        NUMERIC: /^\d*\.?\d*$/,
        NUMONLY: /^\d*$/,
        QUANTITY: /^[0-9]{8}$/,
        PERCENTAGE: /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/,
        POSITIVENUMBERS: /^[1-9][0-9]*$/,
        URL: /^(?:(?:https?:\/\/(?:docs\.google\.com\/document\/d\/[A-Za-z0-9_-]+\/edit|en\.wikipedia\.org\/wiki\/[^\s/]+))).*$/i,
        NOTICE_URL: /^(https?:\/\/[^\s]+)$/i,
        LOWERCASE: /[a-z]/,
        UPPERCASE: /[A-Z]/,
        SPECIALCHARSREGEX: /^[a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?\\/~`|-]+$/,
        PAYNUMBER: /^\d{5}$/
    },

    LOCALSTORAGEKEYS: {
          LOGINROLE: 'loginRole',
          ACCESSTOKEN: 'accessToken',
          AUTHUSER: 'authUser',
          REFRESHTOKEN:'refreshToken',
          I18N_LANGUAGE: 'I18N_LANGUAGE',
          FULLNAME: 'fullName',
          NAME: 'name',
    },
    GENERALKEYS: {
        INACTIVE: 'Inactive',
        ACTIVE: 'Active',
        DRIVER: 'Driver',
        MANAGER: 'Manager',
        DELETED: 'Deleted'
    },
    NOTICEMANAGEMENTEXPORTKEY: {
       TITLE: 'title',
       SUBTITLE: 'subtitle',
       NOTICETYPENAME: 'noticetypename',
       DEPOTNAME: 'depotname',
       EXPIRYDATETIME: 'expirydatetime',
       NOTOPEND: 'notopen',
       OPEN: 'open',
       DOWNLOADED:'downloaded',
       SIGNED:'signed',
       DOCUMENTURL: 'documenturl',
    },
    NOTICEDETAILEXPORT: {
        NAME: 'Name',
        EMAIL: 'Email',
        PHONE: 'Phone',
        DEPOT: 'Depot',
        OPEN: 'Open',
        DOWNLOADED: 'Downloaded',
        SIGNED: 'Signed'
    }

};
export default Constant;
